import { VardplatsStatus } from "./types";

// FIXME Kommer In och uttid kommer troligen inte sättas på det här sättet i prod ready version
export const INTID_DEFAULT = "07:00";
export const UTTID_DEFAULT = "11:00";
export const SANG_PREFIX = "sang-";
export const SAL_PREFIX = "sal-";
export const STATUSAR = Object.values(VardplatsStatus).map((value) => ({ value, label: value }));
